import { Grid } from 'antd';

import useHirePortContext from '@/hooks/useHirePortContext';

type PagePadding = {
  paddingInline: number;
  paddingBlock: number;
};

/** Page gutters as explicit axis values so callers can't flip the shorthand. */
export function usePagePadding(embed?: boolean): PagePadding {
  const { renderPageWrapper } = useHirePortContext();
  const screens = Grid.useBreakpoint();
  const isEmbed = embed ?? !renderPageWrapper;

  if (isEmbed) return { paddingInline: 16, paddingBlock: 16 };

  const isMobile = !screens.md;
  return {
    paddingInline: isMobile ? 16 : 32,
    paddingBlock: isMobile ? 16 : 40,
  };
}
